(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tiparts-dealer-map"] && !Shopify.designMode) return;
  try {
    
(() => {
  const assets = () => {
    if (window.tipartsDealerAssets) return window.tipartsDealerAssets;
    const loadCSS = url => { if (!document.querySelector(`link[href="${url}"]`)) { const el = document.createElement('link'); el.rel = 'stylesheet'; el.href = url; document.head.append(el); } };
    const loadJS = url => new Promise((resolve, reject) => { const el = document.createElement('script'); el.src = url; el.async = true; el.onload = resolve; el.onerror = reject; document.head.append(el); });
    loadCSS('https://unpkg.com/leaflet@1.9.4/dist/leaflet.css');
    loadCSS('https://unpkg.com/leaflet.markercluster@1.5.3/dist/MarkerCluster.css');
    window.tipartsDealerAssets = (async () => {
      if (!window.L) await loadJS('https://unpkg.com/leaflet@1.9.4/dist/leaflet.js');
      if (!window.L.markerClusterGroup) await loadJS('https://unpkg.com/leaflet.markercluster@1.5.3/dist/leaflet.markercluster.js');
    })().catch(error => { window.tipartsDealerAssets = null; throw error; });
    return window.tipartsDealerAssets;
  };
  const init = root => {
    if (root.tipartsDealerCleanup) return;
    const $ = selector => root.querySelector(selector);
    const controls = $('.tdm__controls'), query = $('.tdm__search'), country = $('.tdm__country'), radius = $('.tdm__radius');
    const status = $('.tdm__status'), count = $('.tdm__count'), empty = $('.tdm__empty'), mapEl = $('.tdm__map');
    const apiKey = root.dataset.apiKey;
    const events = new AbortController();
    let map, cluster, origin = null, mode = 'text', observer, resizeObserver, request, generation = 0, alive = true, moving = false, busy = false;
    const cache = new Map();
    const normalized = value => String(value).normalize('NFKD').replace(/[\u0300-\u036f]/g, '').toLowerCase().trim();
    const coordinate = value => value.trim() === '' ? NaN : Number(value);
    const dealers = [...root.querySelectorAll('.tdm__card')].map(card => ({card, lat:coordinate(card.dataset.lat), lng:coordinate(card.dataset.lng), marker:null}));
    const valid = d => Number.isFinite(d.lat) && Number.isFinite(d.lng) && Math.abs(d.lat) <= 85.05 && Math.abs(d.lng) <= 180;
    const countries = [...new Set(dealers.map(d => d.card.dataset.country).filter(Boolean))].sort((a,b) => a.localeCompare(b));
    countries.forEach(name => { const option = document.createElement('option'); option.value = name; option.textContent = name; country.append(option); });
    const bind = (el, name, fn) => el.addEventListener(name, fn, {signal:events.signal});
    const setStatus = text => { status.textContent = text; };
    const cancelSearch = () => { generation++; request?.abort(); request = null; busy = false; $('.tdm__controls button[type=submit]').disabled = false; };
    const distance = (a,b) => { const r = Math.PI/180, x=(b.lat-a.lat)*r, y=(b.lng-a.lng)*r; const h=Math.sin(x/2)**2+Math.cos(a.lat*r)*Math.cos(b.lat*r)*Math.sin(y/2)**2; return 6371*2*Math.atan2(Math.sqrt(h),Math.sqrt(Math.max(0,1-h))); };
    const fit = points => {
      if (!map || !points.length) return;
      moving = true;
      if (points.length === 1) map.setView([points[0].lat,points[0].lng],12,{animate:false});
      else map.fitBounds(points.map(d => [d.lat,d.lng]), {padding:[30,30],maxZoom:12,animate:false});
      moving = false;
    };
    const apply = (fitMap = false) => {
      const text = normalized(query.value), selected = country.value, visible = [], radiusKm = Number(radius.value);
      dealers.forEach(d => {
        const matchesCountry = !selected || d.card.dataset.country === selected;
        const haystack = normalized([d.card.dataset.name,d.card.dataset.city,d.card.dataset.country].join(' '));
        d.distance = origin && valid(d) ? distance(origin,d) : null;
        let match = matchesCountry;
        if (mode === 'near') match = match && valid(d) && (!radiusKm || d.distance <= radiusKm);
        else if (mode === 'area' && map) match = match && valid(d) && map.getBounds().contains([d.lat,d.lng]);
        else match = match && (!text || haystack.includes(text));
        d.card.hidden = !match;
        const label = d.card.querySelector('.tdm__distance'); label.hidden = !(match && d.distance !== null); label.textContent = d.distance === null ? '' : `${d.distance.toFixed(1)} km`;
        if (match) visible.push(d);
      });
      if (origin) visible.sort((a,b) => (a.distance ?? Infinity)-(b.distance ?? Infinity));
      visible.forEach(d => $('.tdm__list').append(d.card));
      count.textContent = `${visible.length} ${root.dataset.results}${mode === 'near' && origin?.label ? ' · '+root.dataset.near+' '+origin.label : ''}`;
      empty.hidden = visible.length > 0;
      if (cluster) {
        const markers = new Set((mode === 'area' ? dealers.filter(d => !selected || d.card.dataset.country === selected) : visible).filter(d => d.marker).map(d => d.marker));
        const removed = cluster.getLayers().filter(marker => !markers.has(marker));
        const added = [...markers].filter(marker => !cluster.hasLayer(marker));
        if (removed.length) cluster.removeLayers(removed);
        if (added.length) cluster.addLayers(added);
      }
      if (fitMap) fit(visible.filter(valid));
    };
    const near = (lat,lng,label) => {
      origin = {lat,lng,label}; mode = 'near'; radius.disabled = false;
      apply();
      if (map) { const km = Number(radius.value); const zoom = km === 0 ? 4 : km <= 10 ? 12 : km <= 25 ? 11 : km <= 50 ? 10 : km <= 100 ? 9 : km <= 250 ? 7 : 6; moving = true; map.setView([lat,lng],zoom,{animate:false}); moving = false; }
    };
    bind(query,'input',() => { cancelSearch(); mode='text'; origin=null; radius.disabled=true; setStatus(''); apply(); });
    bind(country,'change',() => { cancelSearch(); if(mode === 'area') {mode='text';origin=null;} apply(mode === 'text'); });
    bind(radius,'change',() => { if(origin && mode === 'near') near(origin.lat,origin.lng,origin.label); });
    bind($('.tdm__reset'),'click',() => { cancelSearch(); query.value='';country.value='';origin=null;mode='text';radius.disabled=true;setStatus('');apply(true); });
    bind(controls,'submit',async event => {
      event.preventDefault();
      const text = query.value.trim();
      if (!text) { cancelSearch(); origin=null;mode='text';radius.disabled=true;apply(true);return; }
      const exact = dealers.filter(d => normalized(d.card.dataset.name) === normalized(text));
      if (exact.length || countries.some(name => normalized(name) === normalized(text))) { cancelSearch(); origin=null;mode='text';radius.disabled=true;setStatus('');apply(true);return; }
      if (!apiKey) {setStatus(root.dataset.keyNeeded);apply(true);return;}
      if (busy) return;
      const token = ++generation; request = new AbortController(); busy=true; $('.tdm__controls button[type=submit]').disabled=true; setStatus(root.dataset.loading);
      const timer = setTimeout(() => request?.abort(),10000);
      try {
        const cacheKey = normalized(text);
        let result = cache.get(cacheKey);
        if (!result) {
          const params = new URLSearchParams({text,format:'json',limit:'1',apiKey});
          const response = await fetch('https://api.geoapify.com/v1/geocode/search?'+params, {signal:request.signal});
          if (!response.ok) throw new Error('Geocoding failed');
          const data = await response.json(); result = data.results?.[0]; if(result) cache.set(cacheKey,result);
        }
        if (!alive || token !== generation) return;
        if (!result || !Number.isFinite(result.lat) || !Number.isFinite(result.lon)) {setStatus(root.dataset.noPlace);return;}
        if (Math.abs(result.lat) > 85.05 || Math.abs(result.lon) > 180) throw new Error('Invalid coordinate');
        near(result.lat,result.lon,result.city || result.name || result.formatted || text); setStatus('');
      } catch(error) { if (alive && token === generation) setStatus(root.dataset.error); }
      finally { clearTimeout(timer); if(alive && token === generation) {busy=false;request=null;$('.tdm__controls button[type=submit]').disabled=false;} }
    });
    bind($('.tdm__locate'),'click',() => {
      cancelSearch(); const token = generation;
      if (!navigator.geolocation) {setStatus(root.dataset.locationError);return;}
      setStatus(root.dataset.loading);
      navigator.geolocation.getCurrentPosition(position => { if(!alive || token !== generation)return; query.value='';country.value='';near(position.coords.latitude,position.coords.longitude,$('.tdm__locate').textContent);setStatus(''); }, () => {if(alive && token === generation)setStatus(root.dataset.locationError);}, {timeout:10000,maximumAge:60000,enableHighAccuracy:false});
    });
    dealers.forEach(d => bind(d.card.querySelector('.tdm__focus'),'click',() => {
      if(!map || !d.marker) {if(!valid(d))setStatus(root.dataset.noPlace);return;}
      moving=true; cluster.zoomToShowLayer(d.marker,() => { if(!alive)return;d.marker.openPopup();moving=false; });
    }));
    bind(document,'shopify:block:select',event => { const d=dealers.find(item => item.card.dataset.blockId === event.detail?.blockId);if(d){cancelSearch();query.value='';country.value='';origin=null;mode='text';radius.disabled=true;apply();d.card.scrollIntoView({block:'nearest'});d.card.querySelector('.tdm__focus').click();} });
    apply();
    const startMap = async () => {
      observer?.disconnect();
      if(!apiKey) {$('.tdm__map-message').textContent=root.dataset.keyNeeded;return;}
      try {
        await assets(); if(!alive)return;
        const L = window.L;
        mapEl.replaceChildren();
        map = L.map(mapEl,{scrollWheelZoom:false,minZoom:2,maxZoom:19}).setView([20,0],Number(root.dataset.zoom));
        const tiles = L.tileLayer('https://maps.geoapify.com/v1/tile/osm-bright-grey/{z}/{x}/{y}.png?apiKey='+encodeURIComponent(apiKey),{maxZoom:19,attribution:'Powered by <a href="https://www.geoapify.com/" target="_blank" rel="noopener">Geoapify</a> | &copy; <a href="https://www.openstreetmap.org/copyright" target="_blank" rel="noopener">OpenStreetMap</a> contributors | &copy; <a href="https://openmaptiles.org/" target="_blank" rel="noopener">OpenMapTiles</a>'}).addTo(map);
        tiles.on('tileerror',() => setStatus(root.dataset.error));
        cluster = L.markerClusterGroup({maxClusterRadius:46,iconCreateFunction:group => { const badge=document.createElement('div');badge.textContent=String(group.getChildCount());badge.className='tdm__cluster';badge.style.width='42px';badge.style.height='42px';badge.style.setProperty('--tdm-accent',root.style.getPropertyValue('--tdm-accent'));return L.divIcon({html:badge,className:'',iconSize:[42,42]}); }}).addTo(map);
        dealers.filter(valid).forEach(d => {
          const pin=document.createElement('div'),inner=document.createElement('div');pin.className='tdm__pin';inner.className='tdm__pin-inner';const logo=$('.tdm__logo');if(logo)inner.append(logo.content.cloneNode(true));else inner.textContent='T';pin.append(inner);
          const popup = d.card.cloneNode(true);
popup.className = 'tdm__card tdm__popup';
popup.hidden = false;
popup.removeAttribute('data-shopify-editor-block');

const heading = popup.querySelector('h2');

// 店名和地址 / Dealer name and address
const address = [...d.card.querySelectorAll('p')]
  .filter(p =>
    !p.querySelector('a') &&
    !p.classList.contains('tdm__distance')
  )
  .map(p => p.textContent.trim())
  .filter(Boolean)
  .join(', ');

const mapsLink = document.createElement('a');
mapsLink.textContent = d.card.dataset.name;
mapsLink.href =
  'https://www.google.com/maps/search/?api=1&query=' +
  encodeURIComponent(
    [d.card.dataset.name, address].filter(Boolean).join(', ')
  );
mapsLink.target = '_blank';
mapsLink.rel = 'noopener noreferrer';

// 白色弹窗内保持黑色店名 / Black name inside white popup
mapsLink.style.color = '#111111';
mapsLink.style.textDecoration = 'underline';

heading.replaceChildren(mapsLink);
popup.querySelector('.tdm__distance')?.remove();
          d.marker=L.marker([d.lat,d.lng],{icon:L.divIcon({html:pin,className:'',iconSize:[38,44],iconAnchor:[19,40],popupAnchor:[0,-36]}),title:d.card.dataset.name}).bindPopup(popup,{closeOnClick:false});
        });
        apply();
        if(mode === 'near' && origin)near(origin.lat,origin.lng,origin.label);else fit(dealers.filter(d => valid(d) && !d.card.hidden));
        map.on('moveend',() => {if(moving)return;cancelSearch();query.value='';origin=null;mode='area';radius.disabled=true;setStatus('');apply();});
        resizeObserver=new ResizeObserver(() => {const previousMoving=moving;moving=true;map.invalidateSize({animate:false});moving=previousMoving;});resizeObserver.observe(mapEl);
      } catch(error) {if(alive){const message=document.createElement('p');message.className='tdm__map-message';message.textContent=root.dataset.error;mapEl.replaceChildren(message);setStatus(root.dataset.error);}}
    };
    if('IntersectionObserver' in window){observer=new IntersectionObserver(entries => {if(entries.some(entry => entry.isIntersecting))startMap();},{rootMargin:'150px'});observer.observe(mapEl);}else startMap();
    root.tipartsDealerCleanup=() => {alive=false;cancelSearch();events.abort();observer?.disconnect();resizeObserver?.disconnect();map?.remove();};
  };
  const prepare = async root => {
    if (root.tipartsDealerCleanup) return;
    const list = root.querySelector('.tdm__list');
    if (!list?.dataset.nextUrl) { init(root); return; }
    const controller = new AbortController();
    let active = true;
    root.tipartsDealerCleanup = () => { active = false; controller.abort(); };
    const seen = new Set(), pending = document.createDocumentFragment();
    let next = list.dataset.nextUrl, failed = false;
    try {
      while (next) {
        const url = new URL(next, window.location.href);
        if (url.origin !== window.location.origin || seen.has(url.href) || seen.size >= 100) throw new Error('Invalid directory page');
        seen.add(url.href);
        url.searchParams.set('section_id', root.dataset.sectionId);
        const timer = setTimeout(() => controller.abort(), 15000);
        let body;
        try {
          const response = await fetch(url, {signal:controller.signal, credentials:'same-origin'});
          if (!response.ok) throw new Error('Directory page unavailable');
          body = await response.text();
        } finally { clearTimeout(timer); }
        const html = new DOMParser().parseFromString(body, 'text/html');
        const page = [...html.querySelectorAll('[data-tiparts-dealer-map]')].find(item => item.dataset.sectionId === root.dataset.sectionId && item.dataset.dealerSource === 'metaobjects');
        const pageList = page?.querySelector('.tdm__list');
        if (!pageList) throw new Error('Directory page missing');
        pageList.querySelectorAll(':scope > .tdm__card').forEach(card => pending.append(document.importNode(card, true)));
        next = pageList.dataset.nextUrl;
      }
    } catch (error) { failed = true; }
    if (!active || !root.isConnected) return;
    if (!failed) { list.append(pending); list.dataset.nextUrl = ''; }
    delete root.tipartsDealerCleanup;
    init(root);
    if (failed) root.querySelector('.tdm__status').textContent = root.dataset.directoryError;
  };
  const scan = scope => {if(scope.matches?.('[data-tiparts-dealer-map]'))prepare(scope);scope.querySelectorAll('[data-tiparts-dealer-map]').forEach(prepare);};
  if(document.readyState === 'loading')document.addEventListener('DOMContentLoaded',() => scan(document),{once:true});else scan(document);
  document.addEventListener('shopify:section:load',event => scan(event.target));
  document.addEventListener('shopify:section:unload',event => {event.target.querySelectorAll('[data-tiparts-dealer-map]').forEach(root => root.tipartsDealerCleanup?.());});
})();

  } catch(e) { console.error(e); }
})();
})();
